import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { useSelector, useDispatch } from "react-redux";
import { toggleMultiSelectDropdown } from "../../../store/slices/dropdown/toggle.slice";
import { locationMapping } from "../../../utils/constant";

const MultiselectDropdownWithBreakdown = ({ steps, selSteps, name, onChange }) => {
  const dispatch = useDispatch();
  const isClose = useSelector((store) => store.toggleDropdown.multiSelectDropdown);
  
  // Initialize once
  const [selectedOptions, setSelectedOptions] = useState(selSteps || []);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  // Only if isClose happens (not props update)
  useEffect(() => {
    setIsOpen(false);
  }, [isClose]);

  // Inform parent whenever internal selection changes
  useEffect(() => {
    onChange(selectedOptions);
  }, [selectedOptions]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleSelect = (e, option) => {
    e.stopPropagation();
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleSelectAll = (e) => {
    e.stopPropagation();
    const allOptions = steps.flatMap(group => group.options);
    if (selectedOptions.length === allOptions.length) {
      setSelectedOptions([]);
    } else {
      setSelectedOptions(allOptions);
    }
  };

  const allOptions = steps.flatMap(group => group.options);

  // Filtered options based on search
  const filteredSteps = steps.map(group => ({
    ...group,
    options: group.options.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    )
  })).filter(group => group.options.length > 0);

  const formatOptionLabel = (option) => {
    if (option === "aelia_auckland") return "Auckland dutyfree";
    return option && option.includes("_") ? option.replace(/_/g, " ") : option;
  };

  return (
    <div className={styles["price-rank-dropdown"]}>
      <button onClick={toggleDropdown} className={styles["dropdown-button"]}>
        <div>
          {selectedOptions.length === allOptions.length
            ? `All ${name || ""}`
            : `${selectedOptions.length}`}
        </div>
        <div className={styles["down"]}>
          <i className="bi bi-chevron-down" style={{ color: "black" }}></i>
        </div>
      </button>

      {isOpen && (
        <div className={styles["dropdown-menu"]} onClick={(e) => e.stopPropagation()}>
          <input
            type="text"
            className={styles["dropdown-search"]}
            placeholder={`Search ${name || ""}`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "100%", marginBottom: 8, padding: 6, fontSize: "1.6rem", borderRadius: 4, border: "1px solid #ccc" }}
          />
          <div className={styles["dropdown-item"]}>
            <input
              type="checkbox"
              checked={selectedOptions.length === allOptions.length}
              onChange={handleSelectAll}
            />
            <label>All {name}</label>
          </div>

          {filteredSteps.map((group, index) => (
            <div key={index}>
              <div className={styles["dropdown-heading"]}>{group.heading}</div>
              {group.options.map((option) => (
                <div key={option} className={styles["dropdown-item"]}>
                  <input
                    type="checkbox"
                    checked={selectedOptions.includes(option)}
                    onChange={(e) => handleSelect(e, option)}
                  />
                  <label>{formatOptionLabel(option)}</label>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiselectDropdownWithBreakdown;
